import React from "react";
import deliverIcon from "../../assets/icons/deliver-icon.svg";
import seenIcon from "../../assets/icons/seen-icon.svg";
import "./MessageReadStatusIndicator.less";

interface MessageReadStatusIndicatorProps {
  isRead: boolean;
}

const MessageReadStatusIndicator: React.FC<MessageReadStatusIndicatorProps> = ({ isRead }) => {
  const icon = isRead ? seenIcon : deliverIcon;
  const alt = isRead ? "Message Seen" : "Message Delivered";

  return (
    <div className="message-read-status-indicator">
      <img className="message-read-status-icon" src={icon} alt={alt} />
    </div>
  );
};

export default MessageReadStatusIndicator;
